export const GoogleMapApiConfig = 'AIzaSyBXBiq3qMi9Jf1yOa9MTbwCgYQi8PVyd8Q';